import { SvgIcon } from '@bob/library'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { CSSpot_Settings_SelfCollapse } from '@websrc/Typings/ContentStack'
import clsx from 'clsx'
import { button, styles } from 'leds'
import React, { ReactNode, useState } from 'react'

import { collapsingContainer } from './SelfCollapse.css'

type Props = {
  collapseSettings: CSSpot_Settings_SelfCollapse
  children: ReactNode
}

export default function SelfCollapse({ collapseSettings, children }: Props) {
  const { collapse_mode, is_initially_collapsed } = collapseSettings
  const [isCollapsed, setIsCollapsed] = useState(is_initially_collapsed)
  const t = useStaticText()

  if (collapse_mode && collapse_mode !== 'disabled') {
    return (
      <>
        <div className={clsx(isCollapsed ? collapsingContainer.isCollapsed[collapse_mode] : '')}>
          {children}
        </div>

        {isCollapsed && (
          <div className={collapsingContainer.button}>
            <button
              className={button({
                type: 'secondary',
                colorTheme: 'blackInverse',
                fontWeight: 'bold',
                fontSize: 'md',
              })}
              onClick={() => {
                setIsCollapsed((currIsCollapsed) => !currIsCollapsed)
              }}
            >
              {!isCollapsed ? (
                <SvgIcon name={'MINUS'} size={14} strokeWidth={8} />
              ) : (
                <SvgIcon name={'PLUS'} size={14} strokeWidth={7} />
              )}
              <span className={styles({ marginLeft: 8 })}>
                {!isCollapsed ? t.spot.collapse_spot : t.spot.expand_spot}
              </span>
            </button>
          </div>
        )}
      </>
    )
  } else return <>{children}</>
}
